import React from 'react';
import { FormField } from 'ui/formField';
import MetricsDropdown from './MetricsDropdown';
import VisualizationList from './VisualizationList';
import {
  visualizations,
  getWidgetSettingsForVisualization,
  getVisualizationsForMetric,
} from '../../utils/visualizations';

// type Props = {
//   /** List of metrics on the dashboard. */
//   metrics: [],
//   /** Callback function when metric or visualization is changed. */
//   onChange: (string) => void,
//   /** Currently selected metric. */
//   selectedMetric: {},
//   /** Currently selected visualization. */
//   selectedVisualization: string,
// };

export default class VisualizationPanel extends React.Component {
  static defaultProps = {
    onChange: () => {},
  };

  /**
   * Callback when selected metric changes.
   * Resets selected widget and gets a list of available widgets.
   *
   * ```
   * handleChangeMetric(e, selectDropDownProps) => {}
   * ```
   * @param { Object } e: The change event.
   * @param { Object } selectDropDownProps: Reference to the metric dropdown
   *                                        containing the changed value.
   * @return { void }
   */
  handleChangeMetric = (e, { value: metric }) => {
    this.props.onChange(e, { settings: { metric, visualization: '' } });
  };

  /**
   * Callback when selected visualization changes.
   *
   * ```
   * handleChangeVisualization(e, visualization) => {}
   * ```
   * @param { Object } e: The click event.
   * @param { String } visualization: The new visualization type selected.
   * @return { void }
   */
  handleChangeVisualization = (e, visualization) => {
    const { settings, ...config } = getWidgetSettingsForVisualization(visualization);
    this.props.onChange(e, { ...config, settings: { ...settings, visualization } });
  };

  render() {
    const { metrics, selectedMetric, selectedVisualization } = this.props;
    return [
      <FormField key="metric-dropdown" labelText="Metric">
        <MetricsDropdown
          onChange={this.handleChangeMetric}
          metrics={metrics}
          selectedMetric={selectedMetric}
        />
      </FormField>,
      <FormField key="visualization-list" labelText="Chart">
        <VisualizationList
          visualizations={visualizations}
          availableVisualizations={getVisualizationsForMetric(selectedMetric)}
          selectedVisualization={selectedVisualization}
          onSelectVisualization={this.handleChangeVisualization}
        />
      </FormField>,
    ];
  }
}
